import {Menu} from "antd";
import {PaxNode} from "../../../__generated__/graphql/types";
import {useMutation} from "react-apollo";
import {DeletePaxNode, RemovePassengerFromFlight} from "../graphql";
import useRemoveFromFlight from "./remove-from-flight";
import {useContext} from "react";
import {OrgDataContext} from "../../../context/orgData";
import useUserGroups from "../../../hooks/useUserGroups";

export default function useDeletePax(paxNode: Pick<PaxNode, '_id' | 'currentCarrierDoc'>){
    const orgData = useContext(OrgDataContext);
    const [ userGroups ] = useUserGroups();
    const { remove: removeFromFlight, loading: removeFlightLoading } = useRemoveFromFlight(paxNode);

    const [ mutate, mutationResult ] = useMutation(DeletePaxNode, {
        variables: {
            paxId: paxNode?._id,
            tpID: orgData.getOrgIDByType('transporter')
        }
    });

    let deletionAllowed = false;

    if (userGroups.includes("flytsuite.live.passenger.delete")){
        deletionAllowed = true;
    }

    async function deletePax(){
        if (!paxNode){
            throw Error("paxNode is null!");
        }
        if (!deletionAllowed){
            throw Error("Deletion is not allowed!");
        }

        // Delete passenger
        return mutate();
    }

    return {
        delete: deletePax,
        deletionAllowed: deletionAllowed,
        loading: mutationResult.loading || removeFlightLoading,
        mutationResult: mutationResult
    };
}